import { cn } from "../../utils/cn"

export default function Button({
  variant = "default",
  size = "default",
  className = "",
  isActive = false,
  children,
  ...props
}) {
  const variants = {
    default: "bg-gray-200 text-gray-800 hover:bg-gray-300",
    login: "bg-button-login text-white hover:bg-button-login-hover w-[386px] h-[59px] rounded-xl",
    dashboard: "bg-button-dashboard text-black font-bold hover:bg-button-dashboard-hover",
    dashboardHeader: isActive ? "bg-linkColor text-white rounded-xl" : "text-gray-600 hover:bg-gray-100 rounded-md",
    sidebarbutton: "bg-button-sidebar text-black rounded-full hover:bg-[#5B93FFE6]", 
    createstudy: "bg-button-create-study text-[#191B1F]  py-6 rounded-full hover:bg-[#5B93FFE6] min-w-[140px]", 
    addbutton: "bg-button-create-study text-[#191B1F]  py-6 rounded-xl hover:bg-[#5B93FFE6] min-w-[120px]",
    addbutton2: "bg-close-study-button text-white py-6 rounded-xl  min-w-[120px]",  
    closestudy: "bg-close-study-button text-white rounded-full px-8 ", 
    closestudy2: "bg-close-study-button text-white rounded-xl px-8 ", 
    icfSignature: "bg-linkColor text-white rounded-xl px-8 ",
    icfCounterSignature : "bg-button-icfSignature text-white  px-8 ",
    dropOut: "bg-close-study-button text-[#191B1F] py-6 rounded-xl  min-w-[120px]", 
    /* addbutton2: "bg-close-study-button text-white py-6 rounded-xl  min-w-[120px]",  */
    QrCoderounded: "bg-[#5b93ff] text-white p-10 rounded-full hover:bg-[#5B93FFE6] min-w-[120px]",
    QrCode: "bg-[#5b93ff] text-white p-10 rounded-lg hover:bg-[#5B93FFE6] min-w-[150px]"

  }

  const sizes = {
    default: "h-12 px-4 py-2",
    sm: "h-9 rounded-md px-3",
    lg: "w-[160px] h-13 rounded-3xl",
    icon: "h-10 w-10",
  }

  return (
    <button
      className={cn(
        "inline-flex items-center justify-center transition-all duration-300",
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  )
}

